var map = {
	"./Aija-Lagzdina.svg": "f413",
	"./Arkadijs-Mazjanis.svg": "bf1a",
	"./Emīls-Pūķis.png": "375b",
	"./Endijs-Karklins.svg": "a05a",
	"./Graziuso-Catello.png": "3d1c",
	"./Jevgenija-Sahovala.svg": "7f6e",
	"./Luigi-Cutolo.svg": "3e5c",
	"./Toms-Sarmanis.svg": "d8cf",
	"./Ulvis-Priedulis.svg": "d796",
	"./antonio-torre.svg": "7ed1",
	"./francesco-casillo.svg": "9432",
	"./francesco-marzullo.svg": "82db",
	"./hbdi-test.svg": "2352",
	"./janos-ujvari.png": "e4f5",
	"./pasquale-scudieri.svg": "6ae4",
	"./wordcloud-aija-lagdzina.png": "b269",
	"./wordcloud-antonio-torre.png": "cfb3",
	"./wordcloud-arkadijs-mazjanis.png": "4297",
	"./wordcloud-emils-pukis.png": "7f97",
	"./wordcloud-endijs-karklins.png": "b333",
	"./wordcloud-francesco-casillo.png": "d126",
	"./wordcloud-francesco-marzullo.png": "3023",
	"./wordcloud-janos-ujvari.png": "16b0",
	"./wordcloud-luigi-cutolo.png": "b672",
	"./wordcloud-pasquale-scudieri.png": "59ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a8f";